export const palette = {
  black: '#000000',
  orange: '#ff8800',
  orange50: '#ffc173',
  orange20: '#ffe5c7',
  orange10: '#fff3e5',
  blue: '#0090d4',
  blue50: '#B2DDF2',
  blue10: '#e0eef5',
  blueLight: '#D9EFF9',
  green: '#00ab3d',
  green30: '#b2e5c4',
  green50: '#7FD59E',
  green10: '#B2E5C4',
  greenLight: '#d9f3e2',
  red: '#e43631',
  red10: '#fef5f5',
  red80: '#e74e49',
  grey: '#393a3b',
  grey60: '#808080',
  grey40: '#9C9C9D',
  grey30: '#c3c3c4',
  grey10: '#ebebeb',
  grey08: 'rgba(57, 58, 59, 0.08)',
  greyLight: '#f0f0f0',
  greyDavy: '#555555',
  greyDark: '#2a2b2b',
  silver: '#f9f9f9',
  white: '#ffffff',
}

export interface IColoredTheme {
  theme?: 'green' | 'blue' | 'orange'
}

export const colors = {
  ...palette,
  portal: palette.orange,
  portalLight: palette.orange50,
  group: palette.blue,
  pack: palette.green,
  text: palette.grey,
  textDisabled: palette.grey30,
  error: palette.red,
  fileUploadZone: palette.greenLight,
  fileUploadZoneBlue: palette.blue10,
  fileUploadZoneText: palette.green,
  fileUploadZoneTextBlue: palette.blue,

  accent: ({ theme }: IColoredTheme): string =>
    (theme === 'green' && palette.green) ||
    (theme === 'blue' && palette.blue) ||
    palette.orange,
  middleAccent: ({ theme }: IColoredTheme): string =>
    (theme === 'green' && colors.green50) ||
    (theme === 'blue' && colors.blue50) ||
    colors.orange50,
  lightAccent: ({ theme }: IColoredTheme): string =>
    (theme === 'green' && palette.greenLight) ||
    (theme === 'blue' && palette.blueLight) ||
    palette.orange20,
}
